export const COLORS = {
  primary: '#309345',
};